document.addEventListener('DOMContentLoaded', () => {

  /*
   * ========================================================
   * PREMIUM HEADER
   * ========================================================
   */

  const headers = document.querySelectorAll(
    '[data-premium-header]'
  );


  headers.forEach((header) => {

    const searchToggle =
      header.querySelector('[data-search-toggle]');

    const searchPanel =
      header.querySelector('[data-search-panel]');

    const searchInput =
      searchPanel?.querySelector('input[type="search"]');

    const mobileToggle =
      header.querySelector('[data-mobile-toggle]');

    const mobileDrawer =
      header.querySelector('[data-mobile-drawer]');

    const closeButtons =
      header.querySelectorAll('[data-mobile-close]');

    const submenuToggles =
      header.querySelectorAll(
        '[data-mobile-submenu-toggle]'
      );


    /*
     * ------------------------------------------------------
     * SEARCH
     * ------------------------------------------------------
     */

    const closeSearch = () => {

      if (!searchPanel || !searchToggle) {
        return;
      }

      searchPanel.classList.remove('is-open');

      searchPanel.setAttribute(
        'aria-hidden',
        'true'
      );

      searchToggle.setAttribute(
        'aria-expanded',
        'false'
      );

    };


    const openSearch = () => {

      if (!searchPanel || !searchToggle) {
        return;
      }

      searchPanel.classList.add('is-open');

      searchPanel.setAttribute(
        'aria-hidden',
        'false'
      );

      searchToggle.setAttribute(
        'aria-expanded',
        'true'
      );

      window.setTimeout(() => {
        searchInput?.focus();
      }, 100);

    };


    searchToggle?.addEventListener(
      'click',
      () => {

        if (
          searchPanel?.classList.contains('is-open')
        ) {
          closeSearch();
        } else {
          openSearch();
        }

      }
    );


    /*
     * ------------------------------------------------------
     * MOBILE DRAWER
     * ------------------------------------------------------
     */

    const closeMobileMenu = () => {

      if (!mobileDrawer || !mobileToggle) {
        return;
      }

      mobileDrawer.classList.remove('is-open');

      mobileDrawer.setAttribute(
        'aria-hidden',
        'true'
      );

      mobileToggle.setAttribute(
        'aria-expanded',
        'false'
      );

      document.documentElement.classList.remove(
        'premium-menu-open'
      );

    };


    const openMobileMenu = () => {

      if (!mobileDrawer || !mobileToggle) {
        return;
      }

      mobileDrawer.classList.add('is-open');

      mobileDrawer.setAttribute(
        'aria-hidden',
        'false'
      );

      mobileToggle.setAttribute(
        'aria-expanded',
        'true'
      );

      document.documentElement.classList.add(
        'premium-menu-open'
      );

    };


    mobileToggle?.addEventListener(
      'click',
      () => {

        if (
          mobileDrawer?.classList.contains('is-open')
        ) {
          closeMobileMenu();
        } else {
          openMobileMenu();
        }

      }
    );


    closeButtons.forEach((button) => {

      button.addEventListener(
        'click',
        closeMobileMenu
      );

    });


    /*
     * ------------------------------------------------------
     * MOBILE SUBMENUS
     * ------------------------------------------------------
     */

    submenuToggles.forEach((toggle) => {

      toggle.addEventListener(
        'click',
        () => {

          const item =
            toggle.closest(
              '.premium-mobile-nav__item'
            );

          const submenu =
            item?.querySelector(
              '[data-mobile-submenu]'
            );

          if (!submenu) {
            return;
          }

          const expanded =
            toggle.getAttribute(
              'aria-expanded'
            ) === 'true';

          toggle.setAttribute(
            'aria-expanded',
            String(!expanded)
          );

          submenu.classList.toggle(
            'is-open',
            !expanded
          );

        }
      );

    });


    /*
     * ------------------------------------------------------
     * TRANSPARENT HEADER
     * ------------------------------------------------------
     */

    const isTransparent =
      header.dataset.transparentActive === 'true';

    const solidify =
      header.dataset.solidifyOnScroll === 'true';


    const updateHeader =
      () => {

        if (!isTransparent || !solidify) {
          return;
        }

        if (window.scrollY > 24) {

          header.classList.add('is-scrolled');

        } else {

          header.classList.remove('is-scrolled');

        }

      };


    updateHeader();


    window.addEventListener(
      'scroll',
      updateHeader,
      { passive: true }
    );


    /*
     * ------------------------------------------------------
     * ESCAPE
     * ------------------------------------------------------
     */

    document.addEventListener(
      'keydown',
      (event) => {

        if (event.key !== 'Escape') {
          return;
        }

        closeSearch();
        closeMobileMenu();

      }
    );

  });


  /*
   * ========================================================
   * ANNOUNCEMENT BAR
   * ========================================================
   */

  const announcements =
    document.querySelectorAll(
      '[data-premium-announcement]'
    );


  announcements.forEach((announcement) => {

    const enabled =
      announcement.dataset.rotationEnabled === 'true';

    if (!enabled) {
      return;
    }


    const items =
      announcement.querySelectorAll(
        '[data-premium-announcement-item]'
      );

    if (items.length < 2) {
      return;
    }


    let current = 0;


    const speed =
      Number(
        announcement.dataset.rotationSpeed || 4
      );


    window.setInterval(() => {

      items[current].classList.remove(
        'is-active'
      );

      current =
        (current + 1) % items.length;

      items[current].classList.add(
        'is-active'
      );

    }, speed * 1000);

  });


});